import React from 'react';
import './InsuranceStep.scss';

const InsuranceStep = ({insuranceStep}) => {

  return (
    <ul className={"insurance-step"}>
      <li>
        <div className={"circle-line"}>
          <div className={"circle-side"} style={insuranceStep === 1 ? {padding: "5px"} : {padding: 0}}>
            <div className={"blue-circle"}></div>
          </div>
          <div className={`${insuranceStep > 1 ? "line-blue" : "line-dot"}`}></div>
        </div>
        <p>نوع بیمه</p>
      </li>

      <li>
        <div className={"circle-line"}>
          <div className={"circle-side"} style={insuranceStep === 2 ? {padding: "5px"} : {padding: 0}}>
            {insuranceStep >= 2 && <div className={"blue-circle"}></div>}
          </div>
          <div className={`${insuranceStep > 2 ? "line-blue" : "line-dot"}`}></div>
        </div>
        <p>انتخاب شخص</p>
      </li>

      <li>
        <div className={"circle-line"}>
          <div className={"circle-side"} style={insuranceStep === 3 ? {padding: "5px"} : {padding: 0}}>
            {insuranceStep >= 3 && <div className={"blue-circle"}></div>}
          </div>
          <div className={`${insuranceStep > 3 ? "line-blue" : "line-dot"}`}></div>
        </div>
        <p>اطلاعات بیمه نامه</p>
      </li>

      <li>
        <div className={"circle-line"}>
          <div className={"circle-side"} style={insuranceStep === 4 ? {padding: "5px"} : {padding: 0}}>
            {insuranceStep >= 4 && <div className={"blue-circle"}></div>}
          </div>
          <div className={`${insuranceStep > 4 ? "line-blue" : "line-dot"}`}></div>
        </div>
        <p>اطلاعات حق بیمه سیستمی</p>
      </li>

      <li>
        <div className={"circle-line"}>
          <div className={"circle-side"} style={insuranceStep === 5 ? {padding: "5px"} : {padding: 0}}>
            {insuranceStep >= 5 && <div className={"blue-circle"}></div>}
          </div>
          <div className={`${insuranceStep > 5 ? "line-blue" : "line-dot"}`}></div>
        </div>
        <p>اصلاح حق بیمه مشتری</p>
      </li>

      <li>
        <div className={"circle-line"}>
          <div className={"circle-side"} style={insuranceStep === 6 ? {padding: "5px"} : {padding: 0}}>
            {insuranceStep >= 6 && <div className={"blue-circle"}></div>}
          </div>
          <div className={`${insuranceStep > 6 ? "line-blue" : "line-dot"}`}></div>
        </div>
        <p>اطلاعات تکمیلی</p>
      </li>

      <li>
        <div className={"circle-line"}>
          <div className={"circle-side"} style={insuranceStep === 7 ? {padding: "5px"} : {padding: 0}}>
            {insuranceStep >= 7 && <div className={"blue-circle"}></div>}
          </div>
        </div>
        <p>تایید اطلاعات</p>
      </li>

    </ul>
  );
};

export default InsuranceStep;